import script from "./WapContactView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapContactView.vue?vue&type=script&lang=ts&setup=true"

import "./WapContactView.vue?vue&type=style&index=0&id=e2db6d12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2db6d12"]])

export default __exports__